<template>
  <table class="numeric-keypad" @click.stop>
    <tbody>
      <tr>
        <td><button class="button is-lead" @click.stop="updateNumber(1)" :disabled="disabled">1</button></td>
        <td><button class="button is-lead" @click.stop="updateNumber(2)" :disabled="disabled">2</button></td>
        <td><button class="button is-lead" @click.stop="updateNumber(3)" :disabled="disabled">3</button></td>
      </tr>
      <tr>
        <td><button class="button is-lead" @click.stop="updateNumber(4)" :disabled="disabled">4</button></td>
        <td><button class="button is-lead" @click.stop="updateNumber(5)" :disabled="disabled">5</button></td>
        <td><button class="button is-lead" @click.stop="updateNumber(6)" :disabled="disabled">6</button></td>
      </tr>
      <tr>
        <td><button class="button is-lead" @click.stop="updateNumber(7)" :disabled="disabled">7</button></td>
        <td><button class="button is-lead" @click.stop="updateNumber(8)" :disabled="disabled">8</button></td>
        <td><button class="button is-lead" @click.stop="updateNumber(9)" :disabled="disabled">9</button></td>
      </tr>
      <tr>
        <td><button class="button clear" @click.stop="clearNumber()" :disabled="disabled">C</button></td>
        <td><button class="button is-lead" @click.stop="updateNumber(0)" :disabled="disabled">0</button></td>
        <td>
          <button class="button delete" @click.stop="deleteNumber()" :disabled="disabled"><deleteIcon /></button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import deleteIcon from '@/components/icons/backspace'
/**
 * 数値入力キーパッド
 */
export default {
  name: 'NumericKeypad',
  components: {
    deleteIcon,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /** 値 */
    value: [Number, String],
    /** 最大値 */
    max: [Number, String],
    /** 画面遷移後に値を変更したか */
    changed: { type: Boolean, default: false },
    /** valueをリセット */
    resettable: { type: Boolean, default: false },
    /** @deprecated value を使用して下さい */
    inputValue: [Number, String],
    /** @deprecated `change` イベントを使用して下さい */
    onInput: { type: Function, default: () => {} },
    /** @deprecated `change` イベントを使用して下さい */
    onDelete: { type: Function, default: () => {} },
    /** @deprecated `change` イベントを使用して下さい */
    onClear: { type: Function, default: () => {} },
    /** disabled */
    disabled: { type: Boolean, default: false },
  },
  methods: {
    updateNumber(value) {
      this.onInput(value)
      value = this.resettable && !this.changed ? value : `${this.value || this.inputValue || ''}${value}`
      if (+value > this.max) return

      /**
       * 値の変更イベント
       * @event change
       * @type {string}
       */
      this.$emit('change', value)
    },
    deleteNumber() {
      this.onDelete()
      this.$emit('change', `${this.value || this.inputValue || ''}`.slice(0, -1))
    },
    clearNumber() {
      this.onClear()
      this.$emit('change', '')
    },
  },
}
</script>

<style lang="postcss" scoped>
.numeric-keypad {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 auto;
  width: 216px;

  .popover & {
    margin: 10px 12px;
    z-index: 5;
  }

  tr {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  tr + tr {
    margin-top: 12px;
  }

  .button {
    appearance: none;
    background-color: var(--white);
    border-radius: 32px;
    box-shadow: none;
    color: var(--brand-color);
    font-family: inherit;
    font-size: 32px;
    font-weight: 700;
    height: 64px;
    padding: 0;
    text-align: center;
    width: 64px;

    &.is-lead {
      background-color: var(--brand-color);
      border: 0;
      color: var(--white);
    }

    &:disabled {
      background-color: var(--light-gray);
      color: var(--very-light-gray);
    }

    &.delete {
      align-items: center;
      display: flex;
      justify-content: center;

      > svg {
        fill: var(--moderate-blue);
        margin-left: -6px;
      }
    }

    &.delete,
    &.clear {
      border: 2px solid var(--moderate-blue);

      &:disabled {
        background-color: var(--mostly-white-1);
        border-color: var(--light-gray);
        color: var(--very-light-gray);

        > svg {
          fill: var(--light-gray);
        }
      }
    }
  }
}
</style>
